import Particles from "react-tsparticles"
import { Container } from "./styles";
import { Hero } from "../Hero/Hero";
import { About } from "../About/About";
import { Contact } from "../Contact/Contact";
import { Project } from "../Project/Project";

import htmlIcon from "../../assets/html-icon.svg";
import cssIcon from "../../assets/css-icon.svg";
import sassIcon from "../../assets/sass-icon.svg";
import jsIcon from "../../assets/js-icon.svg";
import nodeIcon from "../../assets/node-icon.svg";
import reactIcon from "../../assets/react-icon.svg";
import typescriptIcon from "../../assets/typescript-icon.svg";
import vueIcon from "../../assets/vue-icon.svg";
import boostrapIcon from "../../assets/bootstrap-icon.svg";
import { Work } from "../work/work";
import { Education } from "../Education/Education";
// import reactIcon from "../../assets/react-icon.svg";
// import typescriptIcon from "../../assets/typescript-icon.svg";
// import vueIcon from "../../assets/vue-icon.svg";
// import nodeIcon from "../../assets/node-icon.svg";
// import htmlIcon from "../../assets/html-icon.svg";
// import cssIcon from "../../assets/css-icon.svg";
// import sassIcon from "../../assets/sass-icon.svg";
// import jsIcon from "../../assets/js-icon.svg";
import java from "../../assets/java.svg";

import mongoIcon from "../../assets/mongodb.svg";
import mysqlIcon from "../../assets/mysql-icon.svg";
import firebaseIcon from "../../assets/firebase.svg";
import dynamoDbIcon from "../../assets/DynamoDB.svg";
import awsIcon from "../../assets/aws.svg";
import dockerIcon from "../../assets/docker.svg";
import gitHubIcon from "../../assets/github-icon.svg";
import gitLabIcon from "../../assets/gitlab.svg";
import bitBucket from "../../assets/bitbucket.svg";
import kubernetesIcon from "../../assets/kubernetes.svg";
import jenkinsIcon from "../../assets/jenkins.svg";
import nextjsIcon from "../../assets/nextjs.svg";
import nestjsIcon from "../../assets/nestjs.svg";
import springBootIcon from "../../assets/spring-boot.svg";
import pythonIcon from "../../assets/python.svg";
import { Certifications } from "../Certifications/Certifications";
import { ActivitiesAndAchievements } from "../ActivitiesAndAchievements/ActivitiesAndAchievements";
export function Main() {
  const iconsArray = [
    {
      src: reactIcon,
      width: 20,
      height: 20
    },
    {
      src: typescriptIcon,
      width: 20,
      height: 20
    },
    {
      src: vueIcon,
      width: 20,
      height: 20
    },
    {
      src: nodeIcon,
      width: 20,
      height: 20
    },
    {
      src: htmlIcon,
      width: 20,
      height: 20
    },
    {
      src: cssIcon,
      width: 20,
      height: 20
    },
    {
      src: sassIcon,
      width: 20,
      height: 20
    },
    {
      src: jsIcon,
      width: 20,
      height: 20
    },
    {
      src: java,
      width: 20,
      height: 20
    },
    {
      src: mongoIcon,
      width: 20,
      height: 20
    },
    {
      src: mysqlIcon,
      width: 20,
      height: 20
    },
    {
      src: boostrapIcon,
      width: 20,
      height: 20
    },
    {
      src: firebaseIcon,
      width: 20,
      height: 20
    },
    {
      src: dynamoDbIcon,
      width: 20,
      height: 20
    },
    {
      src: awsIcon,
      width: 20,
      height: 20
    },
    {
      src: dockerIcon,
      width: 20,
      height: 20
    },
    {
      src: gitHubIcon,
      width: 20,
      height: 20
    },
    {
      src: gitLabIcon,
      width: 20,
      height: 20
    },
    {
      src: bitBucket,
      width: 20,
      height: 20
    },
    {
      src: kubernetesIcon,
      width: 20,
      height: 20
    },
    {
      src: jenkinsIcon,
      width: 20,
      height: 20
    },
    {
      src: nextjsIcon,
      width: 20,
      height: 20
    },
    {
      src: nestjsIcon,
      width: 20,
      height: 20
    },
    {
      src: springBootIcon,
      width: 20,
      height: 20
    },
    {
      src: pythonIcon,
      width: 20,
      height: 20
    }
  ];
  

  return (
    <Container>
      <Particles
        id="tsparticles"
        options={{
          "fullScreen": {
            "enable": true,
            "zIndex": 1
          },
          "detectRetina": true,
          "fpsLimit": 60,
          "interactivity": {
            "events": {
              "onClick": {
                "enable": true,
                "mode": "grab"
              },
              "onDiv": {
                "elementId": "repulse-div",
                "enable": false,
                "mode": "gap"
              },
              "onHover": {
                "enable": true,
                "mode": "slow",
                "parallax": {
                  "enable": false,
                  "force": 60,
                  "smooth": 10
                }
              },
              "resize": true
            },
            "modes": {
              "bubble": {
                "distance": 400,
                "duration": 2,
                "opacity": 0.8,
                "size": 2,
              },
              "connect": {
                "distance": 80,
                "lineLinked": {
                  "opacity": 0.5
                },
                "radius": 60
              },
              "grab": {
                "distance": 400,
                "lineLinked": {
                  "opacity": 1
                }
              },
              "push": {
                "quantity": 2
              },
              "remove": {
                "quantity": 2
              },
              "repulse": {
                "distance": 200,
                "duration": 0.4
              }
            }
          },
          "particles": {
            "color": {
              "value": "#ffffff"
            },
            "lineLinked": {
              "blink": false,
              "color": "#000",
              "consent": false,
              "distance": 150,
              "enable": false,
              "opacity": 0.4,
              "width": 1
            },
            "move": {
              "attract": {
                "enable": false,
                "rotate": {
                  "x": 600,
                  "y": 1200
                }
              },
              "bounce": false,
              "direction": "none",
              "enable": true,
              "outMode": "out",
              "random": false,
              "speed": 2,
              "straight": false
            },
            "number": {
              "density": {
                "enable": true,
                "area": 800
              },
              "limit": 30,
              "value": 15,
            },
            "opacity": {
              "animation": {
                "enable": true,
                "minimumValue": 0.2,
                "speed": 1,
                "sync": false
              },
              "random": true,
              "value": 1
            },
            "rotate": {
              "animation": {
                "enable": true,
                "speed": 5,
                "sync": true
              },
              "direction": "random",
              "random": true,
              "value": 0
            },
            "shape": {
              "character": {
                "fill": true,
                "font": "Verdana",
                "style": "",
                "value": "*",
                "weight": "400"
              },
              "image": iconsArray,
              "polygon": {
                "sides": 5
              },
              "stroke": {
                "color": "#000000",
                "width": 0
              },
              "type": "image"
            },
            "size": {
              "animation": {
                "enable": false,
                "minimumValue": 0.1,
                "speed": 40,
                "sync": false
              },
              "random": false,
              "value": 16
            }
          },
          "polygon": {
            "draw": {
              "enable": false,
              "lineColor": "#ffffff",
              "lineWidth": 0.5
            },
            "move": {
              "radius": 10
            },
            "scale": 1,
            "url": ""
          },
          "background": {
            "image": "",
            "position": "50% 50%",
            "repeat": "no-repeat",
            "size": "cover"
          }
        }}
      />
      <Hero></Hero>
      <About></About>
      <Work></Work>
      <Education></Education>
      <Project></Project>
      <Certifications/>
      <ActivitiesAndAchievements/>
      <Contact></Contact>
    </Container>
  );
}
